<!--
 * @Author: zouyuping
 * @version: 
 * @Date: 2022-04-18 15:48:13
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-07-25 17:05:01
 * @FilePath: 
 * @Description: 从小程序跳转来公众号获取公众号的openId
-->
<template>
  <div></div>
</template>

<script>
import wx from "weixin-js-sdk";
import { handleLocalStorage, getUrlParam } from "@/utils/index";
import { getOpenId } from "@/api/user";
export default {
  name: "FromWechatProgram",
  props: {},
  data() {
    return {};
  },
  components: {},
  async created() {
    // const code = getUrlParam("code");
    // const local = window.location.href;
    // if (!code) {
    //   let appId;
    //   if (handleLocalStorage.get("appId")) {
    //     appId = handleLocalStorage.get("appId");
    //   } else {
    //     console.log("获取appId");
    //     let Url = encodeURIComponent(window.location.href.split("#")[0]);
    //     let sendParams = { url: Url };
    //     const tokenRes = await this.$http(
    //       "wechath5/zh-cn/v1/wrapper/jssdk",
    //       sendParams
    //     );
    //     if (tokenRes.AppId) {
    //       appId = res.AppId;
    //     }
    //   }

    //   const redirectUrl =
    //     "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
    //     appId +
    //     "&redirect_uri=" +
    //     encodeURIComponent(local) +
    //     "&response_type=code&scope=snsapi_base&state=1#wechat_redirect";
    //   window.location.href = redirectUrl;
    // } else {
    //   let res = await getOpenId(code); //请求接口换取openId

    // let openId = res.openid;
    let openId = localStorage.getItem("openId");
    console.log("公众号页面openid------------");
    console.log(openId);
    // 跳转回小程序
    const backUrl = "/pages/initOpenidPage/initOpenidPage?openId=" + openId;
    wx.miniProgram.redirectTo({ url: backUrl });
    // }
  },
  mounted() {},
  methods: {},
};
</script>
<style scoped lang="scss"></style>
